import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { Portuguese } from "flatpickr/dist/l10n/pt.js"

export default class extends Controller {
  connect() {
    flatpickr(this.element, {
      locale: Portuguese,
      enableTime: this.element.classList.contains("datetimepicker") || this.element.classList.contains("timepicker"),
      noCalendar: this.element.classList.contains("timepicker"),
      dateFormat: this.element.classList.contains("datetimepicker") ? "d/m/Y H:i" :
                  this.element.classList.contains("timepicker") ? "H:i" : "d/m/Y",
      time_24hr: true,
      allowInput: true,
      closeOnInput: true
    })
  }
}
